import produce from 'immer'
import * as C from './constants'

const sipReducer = (state = C.INITIAL_STATE, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case C.CREATE_CONFIG_SESSION_OPTIONS:
        if (action.payload) {
          draft.sessionOptions.pcConfig.iceServers = [{ urls: action.payload }]
        } else {
          delete draft.sessionOptions.pcConfig.iceServers
        }
        break
      case C.CREATE_CONFIG_FULFILLED:
        draft.config = action.payload
        break
      case C.CREATE_USER_AGENT_FULFILLED:
        draft.userAgent = action.payload
        break
      case C.REGISTER_USER_AGENT_REJECTED:
        draft.error = true
        break
      case C.FETCH_CREDENTIALS_FULFILLED:
        draft.config.username = action.payload.username
        draft.config.password = action.payload.password
        break
      default:
        break
    }
  })
}

export default sipReducer
